import { render } from "./LbrxCountdown.vue?vue&type=template&id=1d85194e&scoped=true"
import script from "./LbrxCountdown.vue?vue&type=script&lang=js"
export * from "./LbrxCountdown.vue?vue&type=script&lang=js"

import "./LbrxCountdown.vue?vue&type=style&index=0&id=1d85194e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d85194e"]])

export default __exports__